module.exports = __webpack_public_path__ + "static/media/view3.d3a4a779.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/view3.png
// module id = 225
// module chunks = 0